module.exports = __webpack_public_path__ + "static/img/top_hover.0cfcd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/pc/top_hover.png
// module id = 4fhi
// module chunks = 10